import React from "react";
import "./labelModalPure.css";
/**
 * @typedef {Object} Props
 * @property {String} label El texto que se mostrara en el modal
 * ```js
 * ¿Estás seguro de eliminar la pregunta?
 * @param {Props}
 * @return {JSX.Element} 
 */
const LabelModalPure = ({label}) => {
    return(
        <div className="labelModalPure-container">
            <p className="labelModalPure-label">{label}</p>
        </div>
    )
}

export { LabelModalPure as default }